import { FileDownloadActions, FileDownloadActionType } from "./file-download.actions";
import { createFileDownloadState } from "../types/file-download.functions";
import { IFileDownloadState } from "../types/file-downolad.interface";

export function fileDownloadReducer(
  state = createFileDownloadState(),
  action: FileDownloadActionType
): IFileDownloadState {
  switch (action.type) {
    case FileDownloadActions.Download:
      return {
        errors: null,
        fetching: true,
      };
    case FileDownloadActions.DownloadFailure:
      return {
        errors: action.payload,
        fetching: false,
      };
    case FileDownloadActions.DownloadSuccess:
      return {
        errors: null,
        fetching: false,
      };
    default:
      return state;
  }
}
